import React from 'react';
import { errorStyles } from './styles';

const ErrorFallback = ({ error, onReset, onGoHome }) => (
  <div style={errorStyles.container}>
    <img 
      src="/error-illustration.svg" 
      alt="Error" 
      style={errorStyles.illustration} 
    />
    
    <h1 style={errorStyles.heading}>
      Oops! Something went wrong
    </h1>

    <p style={errorStyles.message}>
      We're sorry, but something unexpected happened. Our team has been notified and is working on it.
    </p>

    <div style={errorStyles.buttonContainer}>
      <button 
        onClick={onReset}
        style={errorStyles.primaryButton}
      >
        Try Again
      </button>
      <button 
        onClick={onGoHome}
        style={errorStyles.secondaryButton}
      >
        Go to Homepage
      </button>
    </div>

    {process.env.NODE_ENV === 'development' && (
      <details style={errorStyles.errorDetails}>
        <summary style={errorStyles.errorSummary}>Error Details</summary>
        <pre style={errorStyles.errorStack}>{error.toString()}</pre>
      </details>
    )}
  </div>
);

export default ErrorFallback;